import { ChartData } from 'chart.js';
import { Line } from 'react-chartjs-2';
import { useTranslation } from 'react-i18next';
import './chartConfig';

// interface RevenueChartProps {
//   chartData: {
//     labels: string[];
//     datasets: any[];
//   };
// }

interface RevenueChartProps {
  chartData: ChartData<'line'>;
}
  
function RevenueChart({ chartData }: RevenueChartProps) {
  const { t } = useTranslation();

  const options = {
    responsive: true,
    plugins: {
      legend: {
        display: true,
        position: 'top' as const,
      },
      tooltip: {
        callbacks: {
          label: function (context: any) {
            return `€ ${context.parsed.y.toLocaleString('nl-NL', { minimumFractionDigits: 2 })}`;
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          callback: function (value: any) {
            return `€ ${value.toLocaleString('nl-NL')}`;
          },
        },
      },
    },
  };

  return (
    <div>
      <h3>{t('financialdashboard.revenue-chart-title')}</h3>
      <Line data={chartData} options={options} />
    </div>
  );
}

export default RevenueChart;
